import { render, staticRenderFns } from "./importConfig.vue?vue&type=template&id=1cdf7c8e"
import script from "./importConfig.vue?vue&type=script&lang=js"
export * from "./importConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports